'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

require('regenerator-runtime/runtime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cachedScripts = [];

var scriptLoader = function scriptLoader() {
  for (var _len = arguments.length, scriptSrcs = Array(_len), _key = 0; _key < _len; _key++) {
    scriptSrcs[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    var ScriptLoader = function (_React$Component) {
      _inherits(ScriptLoader, _React$Component);

      function ScriptLoader(props, context) {
        var _this2 = this;

        _classCallCheck(this, ScriptLoader);

        var _this = _possibleConstructorReturn(this, (ScriptLoader.__proto__ || Object.getPrototypeOf(ScriptLoader)).call(this, props, context));

        _this.loadScripts = function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(srcs) {
            var promises, success;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    promises = srcs.filter(function (src) {
                      return !cachedScripts.includes(src);
                    }).map(function (src) {
                      return _this.loadScript(src);
                    });
                    success = true;
                    _context.prev = 2;
                    _context.next = 5;
                    return Promise.all(promises);

                  case 5:
                    _context.next = 10;
                    break;

                  case 7:
                    _context.prev = 7;
                    _context.t0 = _context['catch'](2);

                    success = false;

                  case 10:
                    if (_this._isMounted) {
                      _context.next = 12;
                      break;
                    }

                    return _context.abrupt('return');

                  case 12:

                    _this.setState({
                      scriptsLoaded: true,
                      scriptsLoadedSuccessfully: success
                    });

                  case 13:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2, [[2, 7]]);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();

        _this.loadScript = function (src) {
          cachedScripts.push(src);

          var script = document.createElement('script');
          script.src = src;
          script.async = true;

          var promise = new Promise(function (resolve, reject) {
            script.addEventListener('load', function () {
              return resolve(src);
            });
            script.addEventListener('error', function (e) {
              return reject(e);
            });
          }).catch(function (e) {
            var index = cachedScripts.indexOf(src);
            if (index >= 0) cachedScripts.splice(index, 1);
            script.remove();
            throw e;
          });

          document.body.appendChild(script);

          return promise;
        };

        _this.state = {
          scriptsLoaded: false,
          scriptsLoadedSuccessfully: false
        };

        _this._isMounted = false;
        return _this;
      }

      _createClass(ScriptLoader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this._isMounted = true;
          this.loadScripts(scriptSrcs);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this._isMounted = false;
        }
      }, {
        key: 'render',
        value: function render() {
          var props = _extends({}, this.props, this.state);

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return ScriptLoader;
    }(_react2.default.Component);

    return (0, _hoistNonReactStatics2.default)(ScriptLoader, WrappedComponent);
  };
};

exports.default = scriptLoader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-script-loader-hoc/dist/index.js
// module id = 1451
// module chunks = 0